import { render } from "./SupplierShowView.vue?vue&type=template&id=8aa710c2&scoped=true"
import script from "./SupplierShowView.vue?vue&type=script&lang=js"
export * from "./SupplierShowView.vue?vue&type=script&lang=js"

import "./SupplierShowView.vue?vue&type=style&index=0&id=8aa710c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8aa710c2"]])

export default __exports__